import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'
import { container } from 'app/sofia/resources/theme/css'

export const Container = styled.div`
  background: ${props => props.theme.palette.general.greyExtraLight};
  padding: 80px 0;

  h3 {
    font: ${font('alt', 'normal', '30px/1.2')};
    text-align: center;
    margin: 0 0 36px;
  }

  .products-wrapper {
    ${container};
    position: relative;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 280px));
    grid-gap: 1vw;
    justify-content: center;
  }

  .item {
    .product-name {
      font-size: 16px;
    }
  }
`

export const Loading = styled.div`
  margin: 0 0 30px;
`
